import React from 'react';
import { Clock, ChevronDown } from 'lucide-react';
import { shifts } from '../data/mock';

const ShiftSelector = ({ selectedShift, onShiftSelect, isExpanded }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  
  const handleSelect = (shift) => {
    onShiftSelect(shift);
    setIsOpen(false);
  };

  const selectedShiftName = selectedShift 
    ? shifts.find(s => s.id === selectedShift)?.name 
    : 'Select shift to start';

  return (
    <div className="w-full">
      <div className="flex items-center gap-2 mb-2">
        <Clock className="w-4 h-4 text-gray-400" />
        <span className="text-xs tracking-[0.2em] text-gray-400 font-mono uppercase">SHIFT</span>
      </div>
      
      <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`w-full px-4 py-3 text-left bg-[#0d1520] border rounded flex items-center justify-between transition-all duration-200 ${
            selectedShift 
              ? 'border-[#d4a636] text-white' 
              : 'border-gray-700 text-gray-400 hover:border-gray-600'
          }`}
        >
          <span className="font-mono">{selectedShiftName}</span>
          <ChevronDown className={`w-5 h-5 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
        </button>
        
        {isOpen && (
          <div className="absolute top-full left-0 right-0 mt-1 bg-[#0d1520] border border-gray-700 rounded overflow-hidden z-50">
            {shifts.map((shift) => (
              <button
                key={shift.id}
                onClick={() => handleSelect(shift.id)}
                className={`w-full px-4 py-3 text-left font-mono transition-colors hover:bg-[#1a2535] ${
                  selectedShift === shift.id ? 'bg-[#1a2535] text-white' : 'text-gray-300'
                }`}
              >
                {shift.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ShiftSelector;
